import { useEffect, useState } from "react"

/** Returns `value` after it has stopped changing for `delayMs`. Used to throttle
 *  search-as-you-type so each keystroke doesn't fire its own request. */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
